module.exports = __webpack_public_path__ + "af4b7ecc8c919563c385fa0b3dc9717d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/banner_frame_1.png
// module id = 182
// module chunks = 0